import '../global.js';
import * as Helper from './Helpers';
import gsap from 'gsap';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import ScrollTrigger from 'gsap/ScrollTrigger';
import LogoMobileWidth from './LogoMobileWidth.js';
import { disableScrollingOnIos, enableScrollingOnIos } from './Helpers';
import LSIPModal from './LSIPModal.js';

gsap.registerPlugin(ScrollTrigger);

class CompaniesFilters {
	static instance = null;

	static create(options) {
		if (!CompaniesFilters.instance) {
			CompaniesFilters.instance = new CompaniesFilters(options);
		} else {
			// If instance already exists, reinitialize it for the new container
			CompaniesFilters.instance.options = Object.assign({}, CompaniesFilters.instance.defaultOptions, options);
			CompaniesFilters.instance.init();
		}
		return CompaniesFilters.instance;
	}

	static destroy(data) {
		if (CompaniesFilters.instance) {
			CompaniesFilters.instance.beforeDestroy(data);
			CompaniesFilters.instance = null;
		}
	}

	get defaultOptions() {
		return {
			container: document,
		};
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.isEnabled = true;
		this.lastScrollPosition = 0;
		this.simpleBar;
		this.isSimpleBar = false;

		this.applied = $('#search').val() ? true : false;
		this.AjaxLoadOnScroll = this.ajaxLoadOnScroll.bind(this);
		this.stickyFilters = this.stickyFilters.bind(this);
		this.mm = gsap.matchMedia();
		this.onResize = this.onResize.bind(this);
		this.lsipModal = new LSIPModal('modal-filter', 'modal-filter-dont-show-again');
		this.init();
		this.previousSearch = $('#search').val();
		
		// Throttle variables for scroll performance
		this.scrollThrottleTimer = null;
		this.scrollThrottleDelay = 100; // ms

		setTimeout(() => {
			window.scroller.update();
		}, 1000);
	}

	init() {
		this.htmlEl = document.documentElement;
		this.bodyEl = document.body;
		this.headerFilter = document.querySelector(
			'#section-companies .filter-heading'
		);
		this.wrapper = document.querySelector('.companies-wrapper');
		this.header = document.querySelector('.header');
		// Cache container references for better performance
		this.companiesContainer = this.options.container.querySelector('#all-companies-list');
		this.companiesList = this.companiesContainer ? this.companiesContainer.querySelector('ul.companies-list') : null;
		this.Filters();
		this.onResize();
		setTimeout(() => {
			this.searchAutocomplete();
		}, 300);
		this.initTransition();
		this.onScrollActions();
		this.initStickyFilters();
		this.initResize();
		this.showCompany();
		this.identifyFounder();
	}

	initTransition() {
		$('#section-companies .row-grid .col').addClass('fade-in');
	}

	updateURL(locations, stages, sectors, investments, search) {
		const params = new URLSearchParams(location.search);

		if (locations.length) {
			params.set('location', locations.join(','));
		} else {
			params.delete('location');
		}

		if (stages.length) {
			params.set('stage', stages.join(','));
		} else {
			params.delete('stage');
		}

		if (sectors.length) {
			params.set('sector', sectors.join(','));
		} else {
			params.delete('sector');
		}

		if (investments.length) {
			params.set('investments', investments.join(','));
		} else {
			params.delete('investments');
		}

		if (search.length) {
			params.set('search', search);
		} else {
			params.delete('search');
		}

		const newURL = `${location.pathname}?${params.toString()}`;
		history.pushState({}, '', newURL);
		window.barba.history.add(newURL, 'companies');
	}

	Filters() {
		$(document).on('change', '.filter-wrap :checkbox', (e) => {
			let value = $(e.target).val();
			let isInvestmentsFilter = $(e.target).closest('ul').data('key') === 'investments';

			if (value === 'all') {
				$(e.target)
					.closest('ul')
					.find('li input')
					.prop('checked', false);
				$(e.target).prop('checked', true);
			} else if (isInvestmentsFilter) {
				// Investments filter - allow multiple selection (both LSVP and LSIP can be selected)
				// No special handling needed, both can be checked simultaneously
			} else {
				// Default behavior for other filters
				$(e.target)
					.parents('ul')
					.find('.filter-all')
					.prop('checked', false);

				if (
					!$(e.target)
						.closest('ul')
						.find('li input:not(.filter-all)')
						.is(':checked')
				) {
					$(e.target)
						.closest('ul')
						.find('.filter-all')
						.prop('checked', true);
				}
			}

			this.filterCount();
			this.getResults(this.getFilters());
		});

		// Add explicit touch event handling for mobile filter labels
		let touchHandledLabel = false;

		$(document).on('touchend', '.filter-wrap label.nice-form', (e) => {
			// Only handle on mobile devices
			if (window.innerWidth >= 768) return;

			// Prevent double-firing
			if (touchHandledLabel) return;
			touchHandledLabel = true;
			setTimeout(() => { touchHandledLabel = false; }, 300);

			// Find the checkbox within this label
			const $checkbox = $(e.currentTarget).find('input[type="checkbox"]');

			if ($checkbox.length) {
				// Prevent default to stop the native label click
				e.preventDefault();

				// Toggle checkbox state
				$checkbox.prop('checked', !$checkbox.prop('checked'));

				// Trigger change event to fire filtering logic
				$checkbox.trigger('change');
			}
		});

		$(document).ready(() => {
			this.initFromURL();
			// Update filter count for all companies pages
			if ($('body').hasClass('page-companies') || $('body').hasClass('page-companies-india')) {
				this.filterCount();
			}
			// Only trigger AJAX load for India companies page
			if ($('body').hasClass('page-companies-india')) {
				this.getResults(this.getFilters(), false);
			}
		});

		$('#reset-filters').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters(), true);
		});

		$('#reset-filters-mobile').on('click', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters(), true);
		});

		$(document).on('click', '.ui-menu-item-wrapper', (e) => {
			this.applied = true;
			this.previousSearch = $(e.target).text();
			this.getResults(this.getFilters(), true);
			this.filterCount();
		});

		$(document).on('submit', 'form.search', (e) => {
			e.preventDefault();
			this.applied = true;
			this.previousSearch = $(e.target).find('input').val();
			this.getResults(this.getFilters(), true);
			this.filterCount();
		});

		$(document).on('click', '.load-more-companies', (e) => {
			let slug = $(e.target).data('slug');
			let page = $(e.target).data('page');
			let scrollPosition = this.getScrollPosition();

			$(e.target)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="16px" height="16px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid">
                <circle cx="12" cy="12" fill="none" stroke="#ffffff" stroke-width="2" r="8" stroke-dasharray="18.84955592153876 8.283185307179586">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 12 12;360 12 12" keyTimes="0;1"/>
                </circle>
            </svg>`);

			setTimeout(() => {
				this.loadMore(
					this.getFilters(),
					slug,
					parseInt(page) + 1,
					scrollPosition,
					this.previousSearch
				);
			}, 200);
		});

		$('.filter-wrap #search').on('keyup', (e) => {
			if (!$('.filter-wrap #search').val() && this.applied) {
				//Scroll to top
				this.previousSearch = '';
				this.getResults(this.getFilters(), true);
				this.filterCount();
				this.applied = false;
			}
			if ($('#search').val()) {
				$('form.search').addClass('filled');
			} else {
				$('form.search').removeClass('filled');
			}
		});

		$('.page-companies, .page-companies-india')
			.find('.reset-field')
			.on('click', (e) => {
				const params = new URLSearchParams(location.search);
				$('#search').val('');
				$('form.search').removeClass('filled');
				if (this.applied) {
					this.previousSearch = '';
					this.getResults(this.getFilters(), true);
					this.applied = false;
				}
			});
	}

	// Fetch checked filters, search field and nonce
	getFilters = () => {
		let locations = [];
		let stages = [];
		let sectors = [];
		let investments = [];

		$('#location-filter input:checked').each((index, element) => {
			locations.push($(element).val());
		});

		$('#stage-filter input:checked').each((index, element) => {
			stages.push($(element).val());
		});

		$('#sector-filter input:checked').each((index, element) => {
			sectors.push($(element).val());
		});

		// Only collect investments if the filter exists
		if ($('#investments-filter').length) {
			$('#investments-filter input:checked').each((index, element) => {
				investments.push($(element).val());
			});
			// If no investments are checked, default to both LSVP and LSIP
			if (investments.length === 0) {
				investments = ['lsvp', 'lsip'];
			}
		} else {
			// If investments filter doesn't exist, default to both
			investments = ['lsvp', 'lsip'];
		}

		let search = this.previousSearch;
		// Try to find nonce in container first, then fallback to document
		let nonce = $(this.options.container).find('#post-filters-nonce').val() || $('#post-filters-nonce').val();
		let spotlight = $(this.options.container).find('.filter').data('spotlight-list') || $('.filter').data('spotlight-list');
		

		return {
			locations,
			stages,
			sectors,
			investments,
			search,
			nonce,
			spotlight,
		};
	};

	// Ajax call
	getResults(
		{ locations, stages, sectors, investments, search, nonce, spotlight },
		shouldScroll
	) {
		// Validate nonce before making request
		if (!nonce) {
			return;
		}

		$('#smooth-wrapper').after('<div class="loading"></div>');
		const sectorsStringList =
			sectors.length > 0 && !sectors.includes('all')
				? sectors.join(', ')
				: '';
		
		const $currentSectorFilters = $(
			'#section-companies .section-spotlight-companies .current_sector_filters'
		);
		
		if (sectorsStringList) {
			$currentSectorFilters.text(sectorsStringList + ':').closest('h6').show();
		} else {
			$currentSectorFilters.closest('h6').hide();
		}
		const props = {
			nonce,
			locations,
			stages,
			sectors,
			investments,
			search,
			spotlight,
		};

		const prefilled_location =
			$('.filter-heading').data('prefilled-location');
		if (
			prefilled_location &&
			prefilled_location.length > 0 &&
			props.locations.length === 0
		) {
			props.locations = [prefilled_location];
		}

		this.ajaxLoadCompanies(
			props,
			(result) => {
				// Update cached references when results are loaded
				if (!this.companiesContainer) {
					this.companiesContainer = this.options.container.querySelector('#all-companies-list');
				}
				
				if ($('#section-companies #all-companies-list ul').length > 0) {
					if (
						typeof result.html_all === 'string' &&
						result.html_all.length > 5
					) {
						const $allCompaniesList = $('#section-companies #all-companies-list');
						$allCompaniesList.attr('data-paged', 1);
						$allCompaniesList.attr('data-is-loading', '');
						$allCompaniesList.attr('data-is-last-page', result.is_last ? 'true' : 'false');
						$allCompaniesList.find('ul').html(result.html_all);
						
						// Update cached reference
						this.companiesList = $allCompaniesList.find('ul')[0];
						
					} else {
						const $allCompaniesList = $('#section-companies #all-companies-list');
						$allCompaniesList.attr('data-is-last-page', 'true');
						$allCompaniesList.find('ul').html(
							'<div class="no-result">No results</div>'
						);
					}
				}

				if (
					$('#section-companies #spotlight-companies-list ul')
						.length > 0
				) {
					if (
						typeof result.html_spotlight === 'string' &&
						result.html_spotlight.length > 5
					) {
						$(
							'#section-companies #spotlight-companies-list ul'
						).html(result.html_spotlight);
						$(
							'#section-companies #spotlight-companies-list'
						).removeClass('hide');
					} else {
						$(
							'#section-companies #spotlight-companies-list ul'
						).html('<div class="no-result">No results</div>');
						$(
							'#section-companies #spotlight-companies-list'
						).addClass('hide');
					}
				}
			},
			() => {
				Helper.OpenCloseNew();
				Helper.HoverClassOnParent();
				$('.loading').remove();

				if (shouldScroll) {
					this.mm.add('(max-width: 991px)', () => {
						enableScrollingOnIos();
						setTimeout(() => {
							if (window.scroller) {
								window.scroller.scrollTo(
									$(
										'#section-companies .section-portfolio-heading'
									)[0],
									{
										duration: 100,
										offset: -this.headerHeight,
									}
								);
							} else {
								window.scrollTo(
									0,
									$(
										'#section-companies .section-portfolio-heading'
									).offset().top - this.headerHeight
								);
							}
						}, 500);
					});

					this.mm.add('(min-width: 992px)', () => {
						requestAnimationFrame(() => {
							window.scroller.scrollTo(
								$(
									'#section-companies .section-portfolio-heading'
								)[0],
								{
									duration: 100,
									offset: -this.headerHeight,
								}
							);
						});
					});
				}

				// Use requestAnimationFrame for smoother updates
				requestAnimationFrame(() => {
					window.updateLocoAndScrollTrigger();
					this.animationListCompany();
				});
			}
		);

		this.updateURL(locations, stages, sectors, investments, search);
	}

	loadMore = (
		{ locations, stages, sectors, investments, search, nonce },
		slug,
		page,
		scrollPosition
	) => {
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: wp_ajax.ajaxurl,
			data: {
				action: 'load_more_founders',
				nonce,
				locations,
				stages,
				sectors,
				investments,
				search,
				slug,
				page,
			},
			success: (result) => {
				setTimeout(() => {
					const parent = $('.row-' + slug);
					parent.append(result.html);
					if (result.is_last) {
						$(`[data-slug='${slug}']`).hide();
					}
					$(`[data-slug='${slug}']`).html('Dive deeper');
					$(`[data-slug='${slug}']`).data('page', page);

					const appended = $('#section-companies .col:not(.fade-in)');

					gsap.set(appended, { alpha: 0 });
					gsap.set(parent.parent(), { height: '100%' });
					// animation
					const invert = 1;

					setTimeout(() => {
						gsap.timeline({
							onComplete: () => {
								if (!appended.hasClass('fade-in')) {
									appended.addClass('fade-in');
								}
							},
						})
							.to(appended, {
								y: 50,
								alpha: 0,
								duration: 1,
								delay: 0.2,
							})
							.to(
								appended,
								{
									y: 0,
									alpha: 1,
									duration: 1,
									ease: 'power4.out',
									stagger: 0.1 * invert,
								},
								'-=0.5'
							);
						LogoMobileWidth.create();
					}, 0);
				}, 0);
			},
			error: (xhr, status, error) => {
				if (xhr.status === 403) {
					// Nonce error - silent fail
				}
				
				$('.loading').remove();
			},
		});
	};

	ajaxLoadCompanies = (filters, onSuccess, onComplete) => {
		if (!filters.nonce) {
			if (onComplete) onComplete();
			return;
		}

		const ajaxData = {
			action: 'founders_filter',
			nonce: filters.nonce,
			locations: filters.locations,
			stages: filters.stages,
			sectors: filters.sectors,
			investments: filters.investments,
			search: filters.search,
			spotlight: filters.spotlight,
		};
		
		// Include paged parameter if provided (for infinite scroll)
		if (filters.paged) {
			ajaxData.paged = filters.paged;
		}

		$.ajax({
			type: 'post',
			dataType: 'json',
			url: wp_ajax.ajaxurl,
			data: ajaxData,
			success: (result) => {
				if (onSuccess) onSuccess(result);
			},
			error: (xhr, status, error) => {
				$('.loading').remove();
			},
			complete: () => {
				if (onComplete) onComplete();
			}
		});
	};

	filterCount = () => {
		let dropdowns = [
			'location',
			'stage',
			'sector',
			'investments',
			'length',
		];
		let number = $('.filter-wrap input:checked').length;

		dropdowns.forEach((dropdown) => {
			let activeFilters = $(`#${dropdown}-filter input:checked`);
			let activeFiltersNumber = activeFilters.length;
			let selected = [];

			activeFilters.each((index, element) => {
				selected.push($(element).val());
			});

			// Special handling for investments filter
			if (dropdown === 'investments') {
				const hasLSVP = selected.includes('lsvp');
				const hasLSIP = selected.includes('lsip');
				
				if (hasLSVP && hasLSIP) {
					$(`#${dropdown}-filter .filter-count`).html('(2)');
				} else if (hasLSVP) {
					$(`#${dropdown}-filter .filter-count`).html('(1)');
				} else if (hasLSIP) {
					$(`#${dropdown}-filter .filter-count`).html('(1)');
				} else {
					// Default to both LSVP and LSIP if nothing is selected
					$(`#${dropdown}-filter .filter-count`).html('(2)');
					$('#investments-input-lsvp').prop('checked', true);
					$('#investments-input-lsip').prop('checked', true);
				}
				
				// Don't count 'all' for investments filter
				if (selected.includes('all')) {
					number -= 1;
				}
				return; // Skip the rest of the logic for investments
			}

			if (selected.includes('all')) {
				activeFiltersNumber -= 1;
				number -= 1;
			}

			if (activeFiltersNumber > 0) {
				$(`#${dropdown}-filter .filter-count`).html(
					`(${activeFiltersNumber})`
				);
			} else {
				$(`#${dropdown}-filter .filter-count`).html('');
				$(`#${dropdown}-filter input.filter-all`).prop('checked', true);
			}
		});

		if (number || $('.filter-wrap #search').val().length) {
			number = number ? `(${number})` : '';
			$('#section-companies .filter-opener .filter-count').html(number);
			$('#section-companies #reset-filters .filter-count').text(number);

			if (window.innerWidth > 767) {
				$('#reset-filters').fadeIn();
			}
		} else {
			$('#section-companies #reset-filters').fadeOut();
			$('#section-companies .filter-opener .filter-count').html('');
		}
	};

	// Initialize filters from URL parameters
	initFromURL = () => {
		const urlParams = new URLSearchParams(window.location.search);

		// Handle investments parameter only if filter exists
		if ($('#investments-filter').length) {
			const investmentsParam = urlParams.get('investments');
			if (investmentsParam) {
				const investments = investmentsParam.split(',');
				// Uncheck all investment checkboxes first
				$('#investments-filter input').prop('checked', false);

				// Check the appropriate checkboxes based on URL parameter
				investments.forEach((investment) => {
					if (investment === 'lsvp') {
						$('#investments-input-lsvp').prop('checked', true);
					} else if (investment === 'lsip') {
						$('#investments-input-lsip').prop('checked', true);
					}
				});
				
				// If no valid investments were checked, default to both LSVP and LSIP
				if (!$('#investments-input-lsvp').is(':checked') && !$('#investments-input-lsip').is(':checked')) {
					$('#investments-input-lsvp').prop('checked', true);
					$('#investments-input-lsip').prop('checked', true);
				}
				
				// Update filter count display after setting defaults
				this.filterCount();
			} else {
				// Default to both LSVP and LSIP if no investments parameter
				$('#investments-input-lsvp').prop('checked', true);
				$('#investments-input-lsip').prop('checked', true);
				// Update filter count display after setting defaults
				this.filterCount();
			}
		}
	};

	// Reset all filters
	resetFilters = () => {
		$('.filter-wrap input:checked').prop('checked', false);
		// Set default both LSVP and LSIP checkboxes as checked for investments filter if it exists
		if ($('#investments-filter').length) {
			$('#investments-input-lsvp').prop('checked', true);
			$('#investments-input-lsip').prop('checked', true);
		}
		$('#section-companies #search').prop('value', '');
		window.updateLocoAndScrollTrigger();
		this.onScrollActions();
		$('form.search').removeClass('filled');
		this.previousSearch = '';
	};

	// Search autocomplete
	searchAutocomplete = () => {
		this.searchContainerCompanies = $('#search')[0];
		if (typeof window.companiesAutocomplete !== 'undefined') {
			$(this.searchContainerCompanies).autocomplete({
				source: window.companiesAutocomplete,
				appendTo: $('.filter-wrap .inner .search')[0],
				minLength: 1,
				autoFocus: false,
				open: (e) => {
					$(e.target).next('.ui-autocomplete').addClass('is-active');
					if (!this.isSimpleBar) {
						this.initSimplebar();
					}
				},
				select: (event, ui) => {
					$(event.target).removeClass('active');
					$(event.target)
						.next('.ui-autocomplete')
						.removeClass('is-active');
				},
				close: () => {
					this.destroySimpleBar();
				},
			});
		}
	};

	initSimplebar() {
		this.isSimpleBar = true;
		this.SimpleBar = new SimpleBar($('.ui-autocomplete')[0]);
	}

	destroySimpleBar() {
		if (this.isSimpleBar) {
			this.isSimpleBar = false;
			this.SimpleBar.unMount();
		}
	}

	enableAutocomplete = () => {
		$('#search').autocomplete('enable');
	};

	getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	destroyAutoComplete() {
		$('#search').autocomplete('destroy');
		if (typeof window.companiesAutocomplete !== 'undefined') {
			window.companiesAutocomplete = undefined;
		}
	}

	beforeDestroy(data) {
		this.destroyAutoComplete();
		this.destroySimpleBar();
		this.AjaxLoadOnScroll = null;
		this.headerFilter = null;
		this.wrapper = null;
		this.boundWrapper = null;
		this.headerHeight = null;
		this.header = null;
		this.lastScrollPosition = null;
		this.initStickyFilters = null;
		this.isSimpleBar = null;
		this.SimpleBar = null;
		// Clear cached references
		this.companiesContainer = null;
		this.companiesList = null;
		window.removeEventListener('resize', this.onResize);
	}

	ajaxLoadCompanies(props = {}, callbackSuccess, callbackComplete) {
		this.getFilters();

		const sendingData = {
			...props,
			...{ action: 'founders_filters' },
		};
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: wp_ajax.ajaxurl,
			data: sendingData,
			success: (result) => {
				callbackSuccess(result);
			},
			error: (result) => {
				// Silent error handling
			},
			complete: () => {
				callbackComplete();
			},
		});
	}

	initResize() {
		window.addEventListener('resize', this.onResize);
	}

	onResize() {
		this.headerHeight = this.header.offsetHeight;
		this.isSmoothScroll =
			this.htmlEl.classList.contains('has-scroll-smooth');
		this.isMobile = window.matchMedia('(max-width: 767px)').matches;
	}

	onScrollActions() {
		window.scroller.on('scroll', this.AjaxLoadOnScroll);
		window.scroller.on('call', (func, action) => {
			if (this.isSmoothScroll) {
				if (func === 'companiesFilter') {
					document.body.classList[
						action === 'enter' ? 'add' : 'remove'
					]('is-filter-sticky');
				}
			}
		});
	}

	ajaxLoadOnScroll() {
		// Throttle scroll events to prevent excessive checks
		if (this.scrollThrottleTimer) {
			return;
		}
		
		this.scrollThrottleTimer = setTimeout(() => {
			this.scrollThrottleTimer = null;
		}, this.scrollThrottleDelay);
		
		// Use cached references for better performance
		const container = this.companiesContainer || this.options.container.querySelector('#all-companies-list');
		if (container === null) return;
		
		const companiesList = this.companiesList || container.querySelector('ul.companies-list');
		if (!companiesList) return;
		
		const isLoading = container.dataset.isLoading;
		const isLastPage = container.dataset.isLastPage === 'true';
		
		// Don't load if already loading or if we've reached the last page
		if (isLoading || isLastPage) {
			return;
		}
		
		// Get current page, default to 1 if not set
		const currentPageAttr = container.getAttribute('data-paged');
		const currentPage = currentPageAttr ? parseInt(currentPageAttr) : 1;
		const nextPage = currentPage + 1;
		
		// Cache scroll position to avoid multiple lookups
		const scrollY = window.scroller.scroll.instance.scroll.y;
		const trigger = container.offsetTop + (container.offsetHeight - window.outerHeight * 3);

		if (scrollY > trigger) {
			const props = this.getFilters();

			// Set loading flag BEFORE making request
			container.dataset.isLoading = 'loading';

			this.ajaxLoadCompanies(
				{ ...props, ...{ paged: nextPage } },
				(data) => {
					// Always clear loading flag first
					container.dataset.isLoading = '';
					
					// Check if this is the last page
					if (data.is_last === true || data.is_last === 'true' || data.is_last === 1) {
						container.dataset.isLastPage = 'true';
					}
					
					if (
						typeof data.html_all === 'string' &&
						data.html_all.length > 5
					) {
						// Append content immediately
						$(companiesList).append(data.html_all);
						
						// Update cached reference if DOM changed
						if (!this.companiesList) {
							this.companiesList = companiesList;
						}
						
						// Only update page number AFTER successful load with content
						container.setAttribute('data-paged', nextPage.toString());
						
						// Use requestAnimationFrame for smoother performance
						requestAnimationFrame(() => {
							window.updateLocoAndScrollTrigger();
							this.animationListCompany();
						});
					} else {
						// No more results - mark as last page
						container.dataset.isLastPage = 'true';
					}
				},
				() => {
					// Clear loading flag on error (don't increment page on error)
					container.dataset.isLoading = '';
				}
			);
		}
	}

	animationListCompany() {
		// Cache the query to avoid repeated DOM queries
		const readyElements = this.options.container.querySelectorAll('.ready-appear-list');
		if (readyElements.length === 0) return;
		
		readyElements.forEach((box) => {
			// Skip if already animated
			if (box.classList.contains('list-animated')) return;
			
			let tlnew = gsap.to(box, {
				scrollTrigger: {
					trigger: box,
					start: 'top 110%',
					end: 'bottom 90%',
					scroller: '[data-scroll-container]',
					markers: false,
				},
				y: 0,
				autoAlpha: 1,
				duration: 0.75,
				ease: 'circ.out',
				delay: 0.1,
				clearProps: 'autoAlpha',
				onStart: (a) => {
					box.classList.add('list-animated');
					box.classList.remove('ready-appear-list');
				},
				onComplete: (a) => {
					if (tlnew && tlnew.scrollTrigger) {
						tlnew.scrollTrigger.kill();
					}
					if (tlnew) {
						tlnew.kill();
					}
					tlnew = null;
				},
			});
		});
	}

	stickyFilters() {
		if (this.headerFilter === null) return;

		this.boundWrapper =
			this.wrapper.getBoundingClientRect().top +
			window.scroller.scroll.instance.scroll.y -
			this.headerHeight;
		const scroll = window.scroller.scroll.instance.scroll.y;

		if (!this.isSmoothScroll) {
			this.stickyFilterTouchPin(scroll);
		}

		this.stickyFiltersHandler(scroll);
		this.lastScrollPosition = scroll;
	}

	stickyFilterTouchPin(scroll) {
		if (scroll > this.boundWrapper) {
			this.headerFilter.classList.add('sticky');
			this.headerFilter.style.top = this.headerHeight - 1 + 'px';
			this.wrapper.style.paddingTop =
				this.headerFilter.offsetHeight + 'px';
			this.bodyEl.classList.add('is-filter-sticky');
		} else {
			this.headerFilter.classList.remove('sticky');
			this.headerFilter.style.top = '';
			this.wrapper.style.paddingTop = '';
			this.bodyEl.classList.remove('is-filter-sticky');
			this.headerFilter.classList.remove('active');
			this.headerFilter.classList.remove('removed');
		}
	}

	stickyFiltersHandler(scroll) {
		if (scroll > this.boundWrapper + 100) {
			const scrollDelta = scroll - this.lastScrollPosition;
			if (scrollDelta > 1) {
				this.headerFilter.classList.remove('active');
				this.headerFilter.classList.add('removed');

				if (!this.isMobile) {
					this.closeTheDropdownFilter();
				}
			} else if (scrollDelta < -1) {
				this.headerFilter.classList.add('active');
				this.headerFilter.classList.remove('removed');
				if (!this.isMobile) {
					this.closeTheDropdownFilter();
				}
			}
		} else {
			this.headerFilter.classList.remove('active');
			this.headerFilter.classList.remove('removed');
		}
	}

	initStickyFilters() {
		window.scroller.on('scroll', this.stickyFilters);
	}

	closeTheDropdownFilter() {
		this.options.container
			.querySelectorAll('[data-more]')
			.forEach((item) => {
				if (item.classList.contains('active')) {
					item.classList.remove('active');
					$(item).next().stop().slideToggle(200);
				}
			});
	}

	showCompany() {
		if (document.querySelector('.page-companies-india')) {
			const allCompany = document.querySelectorAll(
				'.page-companies-india [data-appear-list]'
			);
			const data = Array.from(allCompany).slice(0, 5);
			data.forEach((item) => {
				item.removeAttribute('data-appear-list');
			});
		}
	}

	identifyFounder() {
		const allCompanyFounders =
			document.querySelectorAll('[data-company-id]');
		allCompanyFounders.forEach((item) => {
			item.addEventListener('click', (e) => {
				if (item.hasAttribute('data-spotlight-founders-list')) {
					sessionStorage.setItem('founder', 'true');
				} else {
					sessionStorage.setItem('founder', 'false');
				}
			});
		});
	}

	isLSIPPublished() {
		return $('#investments-filter').length > 0;
	}
}

export default CompaniesFilters;
